export default __webpack_public_path__ + "static/media/practice-test-4.cc54276b.csv";